<template>
  <div>
    <b-row>
      <b-col cols="2">
        <BfInput
          label="Clave*"
          data-key="clave"
          :value="data.clave"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" md="4">
        <BfInput
          label="Nombre*"
          data-key="nombre"
          :value="data.nombre"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
        />
      </b-col>
      <b-col sm="6" md="4">
        <BfInput
          label="Apellidos"
          data-key="apellidos"
          :value="data.apellidos"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" md="4">
        <BfInput
          label="Teléfono"
          data-key="telefono"
          :value="data.telefono"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
        />
      </b-col>
      <b-col sm="6" md="4">
        <BfInput
          label="Email*"
          data-key="email"
          :value="data.email"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
        />
      </b-col>
    </b-row>
     <b-row>
      <b-col sm="12" md="8">
        <BfInput
          label="Observaciones"
          data-key="observaciones"
          :value="data.observaciones"
          :edit-mode="editing"
          :errors="errors"
          @update="updateForm"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 10 }"
        />
      </b-col>
    </b-row>
  </div>


</template>

<script>
export default {
  name: 'CommercialsForm',

  props: {
    data: {
      type: Object,
      default: () => ({
        clave: '',
        nombre: '',
        apellidos: '',
        observaciones: '',
        telefono: '',
      }),
    },
    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },
  },
  data: () => ({
    userData: [],
    user: [],
  }),

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },

  },
};
</script>
